module.exports = __webpack_public_path__ + "img/bg_forbidden_desert.8226b231.jpg";